<template>
  <div class="wrap">
    <div class="container" v-reveal>
      <div class="logo-container">
        <img class="imgUrl" :src="oss('logo.png')" alt="启愉智能 INSPIRER" />
      </div>
      <div class="tabbar-container"><TabBar /></div>
    </div>
    <router-view />
  </div>
</template>
<script setup lang="ts">
import TabBar from "./components/TabBar.vue";
import { oss } from "./utils/oss";
import { onMounted, onBeforeUnmount } from 'vue';
import autofit from 'autofit.js';
onMounted(() => {
  autofit.init({
        dh: 1080,
        dw: 1920,
        resize: true
    })


});

</script>
<style lang="scss">
@font-face {
  font-family: "HYQiHei";
  src: url("./assets/fonts/HYQiHei-60S.otf") format("opentype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
body {
  margin: 0;
  font-family: $font-body;
  color: $text-main;
}
// 锚点跳转时为顶部固定导航（80px）预留遮挡高度
#about, #history, #products, #system,
#product-show, #pain, #advantages, #butler, #spec,
#bigdata, #civic, #precision,
#service, #cases, #process, #advantage, #feedback,
#location, #contact-info, #join, #cooperate {
  scroll-margin-top: 100px;
}
// 滚动入场动画（配合 v-reveal 指令）
.reveal {
  opacity: 0;
  transform: translateY(42px);
  transition: opacity 0.7s ease, transform 0.8s cubic-bezier(0.22, 1, 0.36, 1);
  will-change: opacity, transform;
}
.reveal.reveal-visible {
  opacity: 1;
  transform: translateY(0);
}
input {
  border: none;
  outline: none;
  padding: 0;
  margin: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: none;
  background-color: transparent;
  font-size: inherit;
}
textarea {
  border: none;
  outline: none;
  padding: 0;
  margin: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: none;
  background-color: transparent;
  font-size: inherit;
  width: 100%;
  resize: none;

  border: none;
}
button {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
}
#app {
      width: 100%;
    height: 100%;
}
.wrap {
  width: 100%;
  height: 100%;
  overflow-y: auto;                           
}
 
.container {
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: fixed;
  top: 0;
  z-index: 10;
  background-color: #fff;
  
  .logo-container {
    height: 42px;
    .imgUrl {
      height: 100%;
      width: auto;
      display: block;
    }
  }
  .tabbar-container {
    height: auto;
    width: 700px;
    margin-right: 3;
    margin-right: 360px;
    margin-top: 38px;
  }
}
.global-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
ul {
    list-style: none; 
    padding: 0; 
    margin: 0;
}

</style>